import { TrendingUp, RefreshCw, Lightbulb } from 'lucide-react';

export default function WhyThisMattersNow() {
  return (
    <section className="py-10 px-6 bg-gray-800/30 rounded-xl mb-12 border border-gray-700/30">
      <h2 className="text-2xl font-bold text-white mb-8 text-center">Why this matters now</h2>

      <div className="grid gap-6 md:grid-cols-3">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-red-500/20 mb-4">
            <TrendingUp className="w-6 h-6 text-red-400" />
          </div>
          <h3 className="font-semibold text-white mb-2">AI use at work is exploding</h3>
          <p className="text-sm text-gray-400">
            A growing share of white-collar workers already use AI frequently in their daily work,
            and that percentage is rising fast.
          </p>
        </div>

        <div className="text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-yellow-500/20 mb-4">
            <RefreshCw className="w-6 h-6 text-yellow-400" />
          </div>
          <h3 className="font-semibold text-white mb-2">Jobs are being reshaped</h3>
          <p className="text-sm text-gray-400">
            Tens of millions of roles will be disrupted by AI and automation in the next decade—and
            a similar number created, but with very different skill demands.
          </p>
        </div>

        <div className="text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-blue-500/20 mb-4">
            <Lightbulb className="w-6 h-6 text-blue-400" />
          </div>
          <h3 className="font-semibold text-white mb-2">Most aren't using AI deeply</h3>
          <p className="text-sm text-gray-400">
            Many workers only use AI for surface-level tasks, leaving a huge gap between
            "I've tried ChatGPT" and "I can design workflows with it."
          </p>
        </div>
      </div>

      <p className="text-center text-gray-400 mt-8 max-w-2xl mx-auto">
        Northcoast AI Academy exists to help you move from the first group to the second—safely,
        sanely, and with real thinking skills.
      </p>
    </section>
  );
}
